import { styled } from '@mui/material/styles';

export const wheelPickerClasses = {
  slide: 'slide-styled',
  slides: 'slides-styled',
  containerInner: 'container-inner-styled',
};

export const ContainerStyled = styled('div')`
  display: block;
  width: 100%;
  height: 100%;
`;

export const ContainerInnerStyled = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 55px;
  user-select: none;
  transform-style: preserve-3d;
`;

export const SlidesStyled = styled('div')`
  position: relative;
  width: 100%;
  height: 100%;
  perspective: 1000px;
`;

export const SlideStyled = styled('div')<{ active: boolean }>`
  position: absolute;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: 18px;
  color: ${({ active, theme }) =>
    active ? theme.palette.picker.secondaryActiveText : theme.palette.picker.secondaryInactiveText};
  backface-visibility: hidden;
  will-change: transform;
`;

export const ShadowStyled = styled('div')`
  position: relative;
  left: 0;
  z-index: 5;
  width: 100%;
  height: 43%;
  margin-top: -2px;
  transform: translateX(-10%);
  filter: blur(15px);
`;

export const SlideValueStyled = styled('span')``;
